const messages = {
  threads: {
    orders: {
      title: "Il tuo ordine nel negozio premi",
      content:
        "<p>Gentile Cliente,</p>\n<p>&nbsp;</p>\n<p>Grazie per il tuo ordine nel negozio premi:</p>\n<p>- &nbsp;&gt;&gt;ORDER-ID&lt;&lt;&nbsp;</p>\n<p>- &nbsp;&gt;&gt;ORDER-PRODUCTS&lt;&lt;&nbsp;</p>\n<p>Il tuo ordine &egrave; ora in fase di elaborazione.<br>La consegna pu&ograve; richiedere fino a 3 settimane.</p>\n<p>Distinti saluti</p>\n<p>Il tuo team BRIDGESTONE PLUS</p>",
    },
    externalTraining: { title: "", content: "" },
    InvestmentSupport: { title: "", content: "" },
    onlineTraining: {
      title: "La tua partecipazione alla formazione online",
      content:
        "<p>Gentile cliente,</p>\n<p>&nbsp;</p>\n<p>Grazie per aver preso parte alla formazione online <strong>&nbsp;&gt;&gt;ONLINE_TRAINING_TITLE&lt;&lt ;</ strong> &nbsp;e il quiz.</p>\n<p>Se rispondi correttamente a tutte le domande del quiz avrai un credito di 40 Ricevi punti premio.<br />Congratulazioni.<br /><br />Nota: puoi partecipare al rispettivo quiz una volta per ogni formazione online offerta e assicurarti i punti premio.<br / ><br />Cordiali saluti <br /><br />Il vostro team BRIDGESTONE PLUS<br /><br /></p>",
    },
    bTraining: {
      title: "La tua partecipazione alla formazione online",
      content:
        "<p>Gentile Cliente,</p>\n<p>&nbsp;</p>\n<p>Grazie per la tua partecipazione alla formazione online &gt;&gt;ONLINE_TRAINING_TITLE&lt;&lt; &nbsp;e al quiz.</p>\n<p>Rispondendo correttamente a tutte le domande del quiz, riceverai un credito di 40 punti premio.<br>Congratulazioni.</p>\n<p>Nota: potete partecipare al rispettivo quiz una volta per ogni formazione online offerta e assicurarvi i punti bonus.</p>\n<p>Distinti saluti</p>\n<p>Il tuo team BRIDGESTONE PLUS</p>",
    },
    hunter: { title: "", content: "" },
    profileComplete: {
      title: "Completamento del profilo: congratulazioni",
      content:
        "<p>Gentile Cliente,</p>\n<p>&nbsp;</p>\n<p>Hai completato il tuo profilo utente!</p>\n<p>Vorremmo ringraziarvi sentitamente con 200 punti premio,<br>che sono gi&agrave; stati accreditati sul tuo conto punti.</p>\n<p><br>Distinti saluti</p>\n<p>Il tuo team BRIDGESTONE PLUS</p>",
    },
    activeUser: { title: "", content: "" },
    deleteItemFromOrder: { title: "", content: "" },
    deleteOrder: { title: "", content: "" },
    commitmentLetter: { title: "", content: "" },
    uberall: { title: "", content: "" },
    welcome: { title: "", content: "" },
    booster: {
      title: "I tuoi punti marketing doppi sono ora attivati!",
      content:
        "Gentile utente, riceverai punti booster. Controlla il tuo estratto conto bancario.",
    },
    orderStatus_RETURNED: { title: "", content: "" },
    orderStatus_REJECTED: { title: "", content: "" },
    kickbackPayback: { title: "", content: "" },
    survey_thankyou: { title: "", content: "" },
    survey: { title: "", content: "" },
    salesPromotions: {
      title: "Promozioni di vendita: la tua richiesta",
      content:
        "<p>Gentile Cliente,</p>\n<p>&nbsp;</p>\n<p>Grazie per la tua richiesta e il tuo interesse per le nostre promozioni di vendita.</p>\n<p>Ti sei registrato per le seguenti promozioni:</p>\n<p>&nbsp;</p>\n<p>&gt;&gt;USER_PROMOTIONS&lt;&lt;</p>\n<p>&nbsp;</p>\n<p>La tua attivit&agrave; verr&agrave; aggiunta al localizzatore di rivenditori per le promozioni entro i prossimi 14 giorni e il materiale promozionale per il tuo punto vendita ti verr&agrave; inviato entro 2-3 settimane.</p>\n<p>&nbsp;</p>\n<p>Vi auguriamo tanto successo con le nostre campagne.</p>\n<p><br>Il tuo team BRIDGSTONE PLUS</p>",
    },
  },
};

export default {
  messages,
};
